import {Routes} from '@angular/router';
import {NotFoundComponent} from './pages/not-found/not-found.component';
import {authGuard} from './core/services/guards/auth.guard';

export const appRoutes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule),
        // resolve: [Logged]
    },
    {
        path: 'maintenance',
        loadChildren: () => import('./pages/maintenance/maintenance.module').then(m => m.MaintenanceModule),
    },
    {
        path: '',
        loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule),
        canActivate: [authGuard],
    },
    {
        path: 'not-found',
        component: NotFoundComponent,
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: 'not-found',
        pathMatch: 'prefix',
    },
];